import { Directive, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { GoogleMapsLoaderService } from '@services/google-maps-loader.service';

@Directive({
  selector: '[google-places-autocomplete]',
})
export class GooglePlacesAutocompleteDirective implements OnChanges, OnDestroy {
  @Input() options: google.maps.places.AutocompleteOptions = {};
  @Output() onAddressChange = new EventEmitter<google.maps.places.PlaceResult>();

  private autocomplete?: google.maps.places.Autocomplete;
  private listener?: google.maps.MapsEventListener;

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private mapsLoader: GoogleMapsLoaderService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      this.initAutocomplete();
    }
  }

  private async initAutocomplete(): Promise<void> {
    await this.mapsLoader.load();

    this.destroy();

    const defaultOptions: google.maps.places.AutocompleteOptions = {
      types: ['geocode'],
      componentRestrictions: { country: 'AU' },
    };

    this.autocomplete = new google.maps.places.Autocomplete(this.el.nativeElement, { ...defaultOptions, ...this.options });

    this.listener = this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete?.getPlace();
      if (place) {
        this.onAddressChange.emit(place);
      }
    });
  }

  private destroy(): void {
    if (this.listener) {
      this.listener.remove();
      this.listener = undefined;
    }
    this.autocomplete = undefined;
  }

  ngOnDestroy(): void {
    this.destroy();
  }
}
